export default {
    initial: 'initial',
    started: 'started',
    finished: 'finished',
    abandoned: 'abandoned'
};


// WEBPACK FOOTER //
// ./src/js/workflowStatus.js